import { ContentSection, Card } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { BusinessProspectForm } from './BusinessProspectForm';
import { PrivateProspectForm } from './PrivateProspectForm';
import { useFlowTypeChecker } from '../../../services/common/miscUtils';

export const ProspectPage: FunctionComponent = () => {
  const flowTypeIs = useFlowTypeChecker();
  return (
    <ContentSection pageWrapSize="medium">
      <Card title="">
        {flowTypeIs('consumer') && <PrivateProspectForm />}
        {flowTypeIs('business') && <BusinessProspectForm />}
      </Card>
    </ContentSection>
  );
};
